import { z } from "zod";
import { SxProps } from "@mui/material";
import { schemas } from "../generated/serverClient";
import { SelectInput } from "./SelectInput";

export type Salutation = z.infer<typeof schemas.SalutationEnum>;

const SALUTATION_OPTIONS: Array<[Salutation, string]> = [
  ["Herr", "Herr"],
  ["Frau", "Frau"],
  ["Divers", "Divers"],
  ["MoechteIchNichtSagen", "Möchte ich nicht sagen"],
];

export function SalutationInput(props: { source: string; label: string; disabled?: boolean; sx?: SxProps }) {
  const { source, label, disabled, sx } = props;
  return <SelectInput source={source} label={label} disabled={disabled} sx={sx} options={SALUTATION_OPTIONS} />;
}
